/* import __COLOCATED_TEMPLATE__ from './seller-posting-feedback-bar.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { equal } from '@ember/object/computed';

/** @module */
const SellerPostingFeedbackBar = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {outline|undefined} */
  variant: undefined,

  /** @type {boolean} */
  isOutline: equal('variant', 'outline'),

  /** @type {boolean} */
  isFavorite: false,

  /** @type {boolean} */
  hasFeedback: false,

  /** @type {string} */
  notInterestedText: '',

  /** @type {string} */
  notInterestedTooltip: computed('notInterestedText', function() {
    return this.notInterestedText || 'Not interested?';
  }),

  /**
   * @type {boolean}
   * @private
   */
  _isFavoriteInternal: false,

  /**
   * @type {boolean}
   * @private
   */
  _hasFeedbackInternal: false,

  /**
   * @type {boolean}
   * @private
   */
  _submitting: false,

  /** @inheritDoc */
  didReceiveAttrs() {
    this._super(...arguments);

    const {
      isFavorite: _isFavoriteInternal,
      hasFeedback: _hasFeedbackInternal,
    } = this.getProperties([
      'isFavorite',
      'hasFeedback',
    ]);

    this.setProperties({ _isFavoriteInternal, _hasFeedbackInternal });
  },

  /** @inheritDoc */
  actions: {
    /**
     * @param {MouseEvent} e
     */
    handleFeedback(e) {
      e.stopPropagation();

      if (!this.get('_submitting')) {
        this.get('showFeedback')();
      }
    },

    /**
     * @param {MouseEvent} e
     */
    toggleFavorite(e) {
      e.stopPropagation();

      if (this.get('_submitting')) {
        return;
      }

      this.set('_submitting', true);
      this.get('setFavorite')(this.toggleProperty('_isFavoriteInternal')).finally(() => this.set('_submitting', false));
    },
  },
});

export default SellerPostingFeedbackBar;
